import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  cssVariables: { disableCssColorScheme: true },
  // Paste cuttlecore MUI Sync here. Add ) to the end of pasted code. Format with Prettier. TODO: Automate this using json file or something.
  // Knonwn issues: Must delete & .MuiTouchRipple-root from .MuiButton styleOverrides for used variants below after pasting.

  palette: {
    primary: {
      main: "#9C27B0",
      dark: "#6A1B9A",
      light: "#EDE7F6",
      contrastText: "rgba(255, 255, 255, 0.95)",
    },
    secondary: {
      main: "#D500F9",
      dark: "#E040FB",
      light: "#EA80FC",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    error: {
      contrastText: "#FFFFFF",
      main: "#F44336",
    },
    warning: {
      contrastText: "rgba(0, 0, 0, 0.87)",
      main: "#FFA726",
      dark: "#F57C00",
    },
    info: {
      contrastText: "rgba(0, 0, 0, 0.87)",
      main: "#29B6F6",
    },
    success: {
      contrastText: "rgba(0, 0, 0, 0.87)",
      main: "#66BB6A",
    },
    action: {
      disabled: "rgba(255, 255, 255, 0.38)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "rgba(255, 255, 255, 0.72)",
      disabled: "rgba(255, 255, 255, 0.56)",
    },
  },
  typography: {
    h1: {
      fontSize: "4.5rem",
      fontFamily: "Geist, Helvetica, Arial, sans-serif",
      fontWeight: 400,
    },
    h2: {
      fontSize: "3rem",
      fontFamily: "Geist, Helvetica, Arial, sans-serif",
      fontWeight: 400,
    },
    h3: {
      fontSize: "2rem",
      fontFamily: "Geist, Helvetica, Arial, sans-serif",
    },
    h4: {
      fontSize: "1.5rem",
      fontFamily: "Geist, Helvetica, Arial, sans-serif",
    },
    h5: {
      fontSize: "1.25rem",
      fontFamily: "Geist, Helvetica, Arial, sans-serif",
      fontWeight: 500,
    },
    h6: {
      fontSize: "1rem",
      fontFamily: "Geist, Helvetica, Arial, sans-serif",
      fontWeight: 400,
    },
    body1: {
      fontFamily: "Geist, Helvetica, Arial, sans-serif",
      lineHeight: "160%",
    },
    body2: {
      fontFamily: "Geist, Helvetica, Arial, sans-serif",
    },
    subtitle1: {
      fontSize: "1.5rem",
      fontFamily: "Geist, Helvetica, Arial, sans-serif",
      fontStyle: "normal",
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: "1.25rem",
      fontFamily: "Geist, Helvetica, Arial, sans-serif",
      fontStyle: "normal",
      fontWeight: 400,
    },
    overline: {
      fontFamily: "Geist, Helvetica, Arial, sans-serif",
    },
    caption: {
      fontFamily: "Geist, Helvetica, Arial, sans-serif",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          "&.MuiButton-sizeLarge.MuiButton-containedPrimary": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-primary-contrastText)",
              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-primary-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-primary-contrastText)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-primary-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-containedInherit": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-text-primary)",
              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "#E0E0E0",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-text-primary)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-text-primary)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-containedInherit (white)": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "#E0E0E0",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-containedSecondary": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-secondary-contrastText)",

              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-secondary-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-secondary-contrastText)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-secondary-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-containedError": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-error-contrastText)",

              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-error-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-error-contrastText)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-error-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-containedWarning": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-warning-contrastText)",

              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-warning-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-warning-contrastText)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-warning-contrastText)",
              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-warning-dark)",
              boxShadow: "var(--mui-shadows-4)",
              opacity: "1",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-containedInfo": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-info-contrastText)",

              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-info-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-info-contrastText)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-info-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-containedSuccess": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-success-contrastText)",

              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-success-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-success-contrastText)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-success-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-containedPrimary": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-primary-contrastText)",

              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-primary-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-primary-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-primary-contrastText)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-containedInherit": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-text-primary)",

              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "#E0E0E0",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-text-primary)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-text-primary)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-containedInherit (white)": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",

              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "#E0E0E0",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-common-white_states-main)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-containedSecondary": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-secondary-contrastText)",

              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-secondary-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-secondary-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-secondary-contrastText)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-containedError": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-error-contrastText)",
              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-error-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-error-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-error-contrastText)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-containedWarning": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-warning-contrastText)",
              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-warning-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-warning-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-warning-contrastText)",
              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-warning-dark)",
              boxShadow: "var(--mui-shadows-4)",
              opacity: "1",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-containedInfo": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-info-contrastText)",
              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-info-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-info-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-info-contrastText)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-containedSuccess": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-success-contrastText)",
              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-success-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-success-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-success-contrastText)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-containedPrimary": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-primary-contrastText)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-primary-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-primary-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-primary-contrastText)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-containedInherit": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-text-primary)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "#E0E0E0",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-text-primary)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-text-primary)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-containedInherit (white)": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "#E0E0E0",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-common-white_states-main)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-containedSecondary": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-secondary-contrastText)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-secondary-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-secondary-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-secondary-contrastText)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-containedError": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-error-contrastText)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-error-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-error-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-error-contrastText)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-containedWarning": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-warning-contrastText)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-warning-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-warning-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-warning-contrastText)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-warning-dark)",
              boxShadow: "var(--mui-shadows-4)",
              opacity: "1",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-containedInfo": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-info-contrastText)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-info-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-info-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-info-contrastText)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-containedSuccess": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-success-contrastText)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "var(--mui-palette-success-main)",
              boxShadow: "var(--mui-shadows-6)",
              opacity: "1",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-success-contrastText)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-success-contrastText)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-outlinedPrimary": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-primary-main)",
              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-primary-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "rgba(227, 64, 255, 0.60)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "#D800FC",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-outlinedInherit": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-text-primary)",
              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "1px solid var(--mui-palette-text-primary)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-text-primary)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-text-primary)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-outlinedInherit (white)": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "1px solid var(--mui-palette-common-white_states-main)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-outlinedSecondary": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "#D500F9",
              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-secondary-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "#D500F9",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "#D500F9",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-outlinedError": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-error-main)",
              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-error-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-error-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-error-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-outlinedWarning": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-warning-main)",
              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-warning-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-warning-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-warning-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-outlinedInfo": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-info-main)",
              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-info-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-info-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-info-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-outlinedSuccess": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-success-main)",
              padding: "8px 22px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-success-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-success-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-success-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-outlinedPrimary": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-primary-main)",
              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-primary-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-primary-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-primary-main)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-outlinedInherit": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-text-primary)",
              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "1px solid var(--mui-palette-text-primary)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-text-primary)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-text-primary)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-outlinedInherit (white)": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "1px solid var(--mui-palette-common-white_states-main)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-common-white_states-main)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-outlinedSecondary": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "#D500F9",
              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-secondary-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "#D500F9",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "#D500F9",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-outlinedError": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-error-main)",
              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-error-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-error-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-error-main)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-outlinedWarning": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-warning-main)",

              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-warning-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-warning-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-warning-main)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-outlinedInfo": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-info-main)",

              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-info-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-info-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-info-main)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-outlinedSuccess": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-success-main)",

              padding: "6px 16px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-success-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-success-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-success-main)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-outlinedPrimary": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-primary-main)",

              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-primary-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-primary-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-primary-main)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-outlinedInherit": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-text-primary)",

              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "1px solid var(--mui-palette-text-primary)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-text-primary)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-text-primary)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-outlinedInherit (white)": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "1px solid var(--mui-palette-common-white_states-main)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-common-white_states-main)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-outlinedSecondary": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "#D500F9",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-secondary-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "#D500F9",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "#D500F9",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-outlinedError": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-error-main)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-error-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-error-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-error-main)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-outlinedWarning": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-warning-main)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-warning-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-warning-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-warning-main)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-outlinedInfo": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-info-main)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-info-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-info-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-info-main)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-outlinedSuccess": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-success-main)",
              padding: "4px 10px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border:
                "1px solid var(--mui-palette-success-_states-outlinedBorder)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-success-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-success-main)",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-textPrimary": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-primary-main)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-primary-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-primary-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-textInherit": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-text-primary)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-text-primary)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-text-primary)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-textInherit (white)": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-textSecondary": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "#D500F9",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "#D500F9",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "#D500F9",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-textError": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-error-main)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-error-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-error-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-textWarning": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-warning-main)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-warning-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-warning-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-textInfo": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-info-main)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-info-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-info-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeMedium.MuiButton-textSuccess": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "24px /* 171.429% */",
            letterSpacing: "0.4px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-success-main)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-success-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-success-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "6px 8px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-textPrimary": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-primary-main)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-primary-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-primary-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-textInherit": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-text-primary)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-text-primary)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-text-primary)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-textInherit (white)": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-textSecondary": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "#D500F9",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "#D500F9",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "#D500F9",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-textError": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-error-main)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-error-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-error-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-textWarning": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-warning-main)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-warning-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-warning-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-textInfo": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-info-main)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-info-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-info-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeLarge.MuiButton-textSuccess": {
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.9375rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "26px /* 173.333% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-success-main)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-success-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-success-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
              padding: "8px 11px",
              borderRadius: "var(--mui-shape-borderRadius)",
              border: "0 solid var(--mui-palette-action-disabledBackground)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-textPrimary": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-primary-main)",
              padding: "4px 5px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-primary-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-primary-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-textInherit": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-text-primary)",
              padding: "4px 5px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-text-primary)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-text-primary)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-textInherit (white)": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
              padding: "4px 5px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-common-white_states-main)",
              "& .MuiTouchRipple-root": {
                width: "33.868px",
                height: "38.571px",
                borderRadius: "100px",
                background:
                  "var(--mui-palette-common-white_states-focusVisible)",
                padding: "0",
                opacity: "1",
                boxShadow: "none",
              },
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-common-white_states-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-textSecondary": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "#D500F9",
              padding: "4px 5px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "#D500F9",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "#D500F9",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-textError": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-error-main)",
              padding: "4px 5px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-error-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-error-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-textWarning": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-warning-main)",
              padding: "4px 5px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-warning-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-warning-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-textInfo": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-info-main)",
              padding: "4px 5px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-info-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-info-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
          "&.MuiButton-sizeSmall.MuiButton-textSuccess": {
            fontFamily: "Geist, Helvetica, Arial, sans-serif",
            fontSize: "0.8125rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px /* 169.231% */",
            letterSpacing: "0.46px",
            textTransform: "none",
            "&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-success-main)",
              padding: "4px 5px",
              borderRadius: "var(--mui-shape-borderRadius)",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(.Mui-disabled).Mui-focusVisible:not(:hover)": {
              color: "var(--mui-palette-success-main)",
            },
            "&:not(.Mui-disabled):not(.Mui-focusVisible):hover": {
              color: "var(--mui-palette-success-main)",
            },
            "&.Mui-disabled:not(.Mui-focusVisible):not(:hover)": {
              color: "var(--mui-palette-action-disabled)",
            },
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorDefault)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background: "var(--mui-palette-common-white_states-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorPrimary)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background: "var(--mui-palette-primary-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background: "var(--mui-palette-primary-main)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorError)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background: "var(--mui-palette-error-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background: "var(--mui-palette-error-main)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorWarning)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background: "var(--mui-palette-warning-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background: "var(--mui-palette-warning-main)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorInfo)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background: "var(--mui-palette-info-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background: "var(--mui-palette-info-main)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorSuccess)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background: "var(--mui-palette-success-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background: "var(--mui-palette-success-main)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorSecondary)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(20px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background: "var(--mui-palette-secondary-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background: "var(--mui-palette-secondary-main)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "58px",
                height: "38px",
                transform: "translateX(0px) translateY(0px)",
                padding: "12px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "20px",
                    height: "20px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "34px",
                    height: "14px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorDefault)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background: "var(--mui-palette-common-white_states-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorPrimary)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background: "var(--mui-palette-primary-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background: "var(--mui-palette-primary-main)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorError)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background: "var(--mui-palette-error-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background: "var(--mui-palette-error-main)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorWarning)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background: "var(--mui-palette-warning-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background: "var(--mui-palette-warning-main)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorInfo)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background: "var(--mui-palette-info-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background: "var(--mui-palette-info-main)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorSuccess)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background: "var(--mui-palette-success-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background: "var(--mui-palette-success-main)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorSecondary)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                },
              },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(16px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background: "var(--mui-palette-secondary-main)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background: "var(--mui-palette-secondary-main)",
                    padding: "0",
                    opacity: "0.5",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)":
              {
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))":
              {
                width: "40px",
                height: "24px",
                transform: "translateX(0px) translateY(0px)",
                padding: "7px",
                background: "none",
                opacity: "1",
                borderRadius: "0",
                boxShadow: "none",
                "& .MuiSwitch-switchBase": {
                  transform: "translateX(0px) translateY(0px)",
                  "& .MuiSwitch-thumb": {
                    width: "16px",
                    height: "16px",
                    background:
                      "var(--mui-palette-_components-switch-knobFillEnabled)",
                    boxShadow: "var(--mui-shadows-1)",
                    padding: "0",
                    opacity: "1",
                    borderRadius: "50%",
                  },
                  "& + .MuiSwitch-track": {
                    width: "26px",
                    height: "10px",
                    borderRadius: "100px",
                    background:
                      "var(--mui-palette-_components-switch-slideFill)",
                    padding: "0",
                    opacity: "0.38",
                    boxShadow: "none",
                    transform: "translateX(0px) translateY(0px)",
                  },
                },
              },
          },
        },
      },
    },
  },
});
